import builder from './builder.js';
import UpgradesContainer from './commons/UpgradesContainer';
import Gratuity from './commons/Gratuity';

export default builder(UpgradesContainer, Gratuity);
